import { GuidSection } from "styles/jss/FormPages.styles";
import { useState } from "react";
import GuidInfo from "./GuidInfo";
import { useTranslation } from "next-i18next";

export default function GuidLine({ children }) {
  const { t } = useTranslation(["form"]);
  const POINTS = [
    {
      id: 1,
      title: t("guid.1"),
    },
    {
      id: 2,
      title: t("guid.2"),
    },
    {
      id: 3,
      title: t("guid.3"),
    },
    {
      id: 4,
      title: t("guid.4"),
    },
    {
      id: 5,
      title: t("guid.5"),
    },
    {
      id: 6,
      title: t("guid.6"),
    },
    {
      id: 7,
      title: t("guid.7"),
    },
  ];
  const [open, setOpen] = useState(true);
  return (
    <>
      <GuidSection className={open ? "open" : ""}>
        <div className={"headLine"}>
          <p>{t("guid.title")}</p>
          <i onClick={() => setOpen(!open)}>
            <svg
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.756025 6H9.24397C9.39412 5.99934 9.54072 5.95232 9.66522 5.86487C9.78971 5.77742 9.88653 5.65347 9.94341 5.5087C10.0003 5.36393 10.0147 5.20484 9.98479 5.05154C9.95489 4.89825 9.88203 4.75763 9.77542 4.64747L5.53904 0.233962C5.46846 0.159827 5.38449 0.100985 5.29197 0.0608292C5.19946 0.0206738 5.10022 0 5 0C4.89978 0 4.80054 0.0206738 4.70803 0.0608292C4.61551 0.100985 4.53154 0.159827 4.46096 0.233962L0.22458 4.64747C0.11797 4.75763 0.0451084 4.89825 0.0152068 5.05154C-0.0146947 5.20484 -0.000293145 5.36393 0.056591 5.5087C0.113475 5.65347 0.210287 5.77742 0.334785 5.86487C0.459282 5.95232 0.605875 5.99934 0.756025 6Z"
                fill="#3A3A3A"
              />
            </svg>
          </i>
        </div>
        <ul>
          {POINTS.map(item => (
            <li key={item.id}>
              <i>
                <span>{item.id}</span>
              </i>
              {item.title}
            </li>
          ))}
        </ul>
      </GuidSection>
      <GuidInfo text={t("guid.info")} />
      {children}
    </>
  );
}
